import type { Feature } from '../types';
import { Region, FeatureName, ApplicationChannel } from '../config';

/**
 * UTT Impact
 */
const uttImpact: Feature = {
  featureName: FeatureName.UTT_IMPACT,
  description: 'UTT Impact',
  status: true,
  enabledAppChannels: [ApplicationChannel.WEB],
  enabledRegions: [Region.CA, Region.UK], // 其余市场在GTM集成，因为业务是这样安排的
  payload: {
    [Region.CA]: {
      scriptUrl: 'https://utt.impactcdn.com/A6142198-749e-471e-8764-c60d62dcb7da1.js',
    },
    [Region.UK]: {
      scriptUrl: 'https://utt.impactcdn.com/A6478293-f956-4d4e-997e-3c0b19fb659c1.js',
    },
  },
};

export default uttImpact;
